export enum ClaimantCopyFrom {
  NONE = 'None',
  BILL_TO = 'Bill-To',
  CONSIGNEE = 'Consignee',
  SHIPPER = 'Shipper',
}
